import { Component, Injector } from '@angular/core';
import { BaseResourceListComponent, Coluna, Filtro, FormatoExportacao, FuncaoService, LicitacaoAudesp, LicitacaoAudespPacote, LoginContabil } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { LicitacaoAudespPacoteService } from '../service/licitacao-audesp-pacote.service';
import { LicitacaoAudespService } from '../service/licitacao-audesp.service';

declare var $: any;

@Component({
  selector: 'lib-licitacao-audesp-pacote',
  templateUrl: './licitacao-audesp-pacote.component.html'
})
export class LicitacaoAudespPacoteComponent extends BaseResourceListComponent<any, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public pacoteAtual: LicitacaoAudespPacote;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private funcaoService: FuncaoService,
    private audespService: LicitacaoAudespService,
    private pacoteService: LicitacaoAudespPacoteService) {
    super(pacoteService, injector);
    this.usarFiltroSessao = false;
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return '';
  }

  protected condicoesGrid(): {} {
    return {
      orgao_id: this.login.orgao.id,
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['id$DESC'];
  }

  protected filtrosGrid(): Filtro {
    return {
      number: ['id'],
      text: ['tipo'],
      date: ['data_cadastro']
    };
  }

  protected afterInit(): void {
  }

  protected acaoRemover(model: LicitacaoAudesp): Observable<LicitacaoAudesp> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Código', coluna: 'codigo' },
      { titulo: 'Tipo', coluna: 'tipo' },
      { titulo: 'Cadastro', coluna: 'data_cadastro' },
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = this.relations();
    this.baseResourceService
      .filtrar(1, -1, parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir(`AUDESP - FASE 4`,
              this.login.usuario.nome, this.login.orgao.nome, this.login.brasao, 'portrait',
              'Audesp Fase 4', ['auto', '*', 'auto'], lista.content);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        () => alert('erro ao retornar lista')
      );
  }

  public visualizar(id: number) {
    this.pacoteService
      .obter({ id, relations: 'arquivos', orderBy: 'arquivos.codigo' })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        if (!dados) return;
        this.pacoteAtual = dados;
        $('#dialogAudespPacoteForm').modal('show');
      })
  }

  public enviarPacote() {
    if (!this.pacoteAtual) return
    this.pacoteService
      .enviarPacote(this.pacoteAtual.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        toastr.success('Pacote enviado com sucesso!');
      }, error => toastr.error(error.message ? error.message : error))
  }

  public baixarPacote() {
    if (!this.pacoteAtual) return
    this.audespService.baixarPacote(this.pacoteAtual.id).pipe(takeUntil(this.unsubscribe))
      .subscribe((xml) => {
        if (!xml) return;
        const nomeArquivo = `${this.pacoteAtual.id}_${this.pacoteAtual.tipo}_${this.funcaoService.converteDataBR(this.pacoteAtual.data_cadastro).split('/').join('')}`

        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(this.funcaoService.formatXml(xml)));
        element.setAttribute('download', `${nomeArquivo}.xml`);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }, error => {
        let mensagemXML = String(error.error.payload).split('\n');
        if (mensagemXML.find(str => str.startsWith('ARQUIVO_XML:'))) {
          const xmlInvalido = mensagemXML.splice(mensagemXML.indexOf(mensagemXML.find(str => str.startsWith('ARQUIVO_XML:'))), 1)[0];
        }
        toastr.error(mensagemXML.join('\n'), 'Não foi possível baixar o pacote!');
      });
  }
}
